<template>
  <div class="trash-container" :style="containerStyle">
    <Sidebar v-if="showSidebar" @update-is-closed="handleSidebarToggle" />
    <div class="header">
      <div class="trash-title">
        <h3>ゴミ箱</h3>
      </div>
      <div class="search-box">
        <v-text-field v-model="searchQuery" clearable variant="underlined" label="検索" placeholder="検索"
          append-inner-icon="mdi-magnify" class="search-input" />
      </div>
    </div>

    <div v-if="selectedTab === 'screen'" class="section">
      <div class="tabs">
        <button @click="selectedTab = 'screen'" :class="{ active: selectedTab === 'screen' }">
          ページ
        </button>
        <button @click="selectedTab = 'property'" :class="{ active: selectedTab === 'property' }">
          プロパティ
        </button>
        <button @click="selectedTab = 'card'" :class="{ active: selectedTab === 'card' }">
          カード
        </button>
      </div>
      <div class="all-button">
        <div class="left-buttons">
          <button class="all-select-btn" @click="toggleAllCheck" :disabled="filteredTrashItems.length === 0">
            {{ isAllChecked ? 'すべて解除' : 'すべて選択' }}
          </button>
        </div>
        <div class="right-buttons">
          <button class="all-restore-btn" @click="allRestore" :disabled="filteredTrashItems.length === 0">復元</button>
          <button class="all-delete-btn" @click="allDelete" :disabled="filteredTrashItems.length === 0">消去</button>
        </div>
      </div>
      <div v-for="item in filteredTrashItems" :key="item.screen_id" class="item-card">
        <input type="checkbox" v-model="selectedItems" :value="item" />

        <div class="item-info">{{ item.screen_name }}</div>
        <div class="item-actions">
          <button class="restore-btn" @click="handleRestore([item])">復元</button>
          <button class="delete-btn" @click="handleDelete([item])">削除</button>
        </div>
      </div>
    </div>

    <div v-if="selectedTab === 'property'" class="section">
      <div class="tabs">
        <button @click="selectedTab = 'screen'" :class="{ active: selectedTab === 'screen' }">
          ページ
        </button>
        <button @click="selectedTab = 'property'" :class="{ active: selectedTab === 'property' }">
          プロパティ
        </button>
        <button @click="selectedTab = 'card'" :class="{ active: selectedTab === 'card' }">
          カード
        </button>
      </div>
      <div class="all-button">
        <div class="left-buttons">
          <button class="all-select-btn" @click="toggleAllCheck" :disabled="filteredProperties.length === 0">
            {{ isAllChecked2 ? 'すべて解除' : 'すべて選択' }}
          </button>
        </div>
        <div class="right-buttons">
          <button class="all-restore-btn" @click="allRestore" :disabled="filteredProperties.length === 0">復元</button>
          <button class="all-delete-btn" @click="allDelete" :disabled="filteredProperties.length === 0">消去</button>
        </div>
      </div>
      <div v-for="item in filteredProperties" :key="item.property_id" class="item-card">
        <input type="checkbox" v-model="selectedItems2" :value="item" />
        <div class="item-texts">
          <div class="item-info">{{ item.property_name || "No Property" }}</div>
          <div class="sub-screen-name">{{ item.screen_name }}</div>
        </div> 
        <div class="item-actions">
          <button class="restore-btn" @click="handleRestore([item])">復元</button>
          <button class="delete-btn" style="border: 1px solid blue" @click="handleDelete([item])">
            削除
          </button>
        </div>
      </div>
    </div>

    <div v-if="selectedTab === 'card'" class="section">
      <div class="tabs">
        <button @click="selectedTab = 'screen'" :class="{ active: selectedTab === 'screen' }">
          ページ
        </button>
        <button @click="selectedTab = 'property'" :class="{ active: selectedTab === 'property' }">
          プロパティ
        </button>
        <button @click="selectedTab = 'card'" :class="{ active: selectedTab === 'card' }">
          カード
        </button>
      </div>
      <div class="all-button">
        <div class="left-buttons">
          <button class="all-select-btn" @click="toggleAllCheck" :disabled="filteredCards.length === 0">
            {{ isAllChecked3 ? 'すべて解除' : 'すべて選択' }}
          </button>
        </div>
        <div class="right-buttons">
          <button class="all-restore-btn" @click="allRestore" :disabled="filteredCards.length === 0">復元</button>
          <button class="all-delete-btn" @click="allDelete" :disabled="filteredCards.length === 0">消去</button>
        </div>
      </div>
      <div v-for="item in filteredCards" :key="item.card_id" class="item-card">
        <input type="checkbox" v-model="selectedItems3" :value="item" />
        <div class="item-texts">
          <div class="item-info">{{ item.title }}</div>
          <div class="sub-screen-name">{{ item.screen_name }}</div>
        </div>
        <div class="item-actions">
          <button class="restore-btn" @click="handleRestore([item])">復元</button>
          <button class="delete-btn" @click="handleDelete([item])">削除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import trashApi from "../api/trash";
import Sidebar from "@/components/Sidebar.vue";
import eventBus from "@/eventBus";

export default {
  name: "TrashPage",
  components: {
    Sidebar,
  },
  data() {
    return {
      selectedTab: "screen",
      searchQuery: "",
      trashItems: [],
      properties: [],
      cards: [],
      isSidebarClosed: false,
      showSidebar: true,
      boardViewVisible: true,
      selectedItems: [],
      selectedItems2: [],
      selectedItems3: [],
      isAllChecked: false,
      isAllChecked2: false,
      isAllChecked3: false,
    };
  },
  async created() {
    await this.fetchTrashItems();
  },
  methods: {
    handleSidebarToggle(isClosed) {
      this.isSidebarClosed = isClosed;
    },
    async fetchTrashItems() {
      try {
        const response = await trashApi.getDeletedItems();
        const { trashItems, properties, cards } = response;
        this.trashItems = trashItems || [];
        this.properties = properties || [];
        this.cards = cards || [];
      } catch (error) {
        console.error(error);
      }
    },
    async handleRestore(items) {
      const confirmRestore = window.confirm("復元しますか？");
      if (!confirmRestore) return;
    
      try {
        const itemType = this.selectedTab;
    
        const requestData = {
          items: items.map(item => ({
            item_id:
              itemType === "screen"
                ? item.screen_id
                : itemType === "property"
                  ? item.property_id
                  : item.card_id,
            item_type: itemType,
          }))
        };
    
        await trashApi.restoreItem(requestData);
    
        eventBus.emit("refreshSidebar");
        this.fetchTrashItems();
        alert("復元が完了しました");
    
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const confirmDelete = window.confirm(
            "該当カードのステータスが削除されて復元が出来ません。カードも完全に削除しますか？?"
          );
          if (confirmDelete) {
            try {
              this.handleDelete(items, true);
              eventBus.emit("refreshSidebar");
              this.fetchTrashItems();
            } catch (deleteError) {
              alert("エラーが発生して削除が出来ませんでした。");
              console.error(deleteError);
            }
          }
        } else if (error.response && error.response.status === 423) {
          const deletedItems = error.response.data.deletedItems;
          if (deletedItems && deletedItems.length > 0) {
          const names = deletedItems.join(", ");
          alert(
             `以下のカードはステータスが削除されているため、復元できませんでした：\n${names}\n個別に復元をお試しください。`
           );
          this.fetchTrashItems();
        } }else {
          console.error("復元中のエラー:", error);
          alert("復元に失敗しました。");
        }
      }
    },
    async handleDelete(items, skipConfirm = false) {
      if (!skipConfirm) {
        const confirmDelete = window.confirm("本当に削除しますか？");
        if (!confirmDelete) return;
      }
      try {
        const itemType = this.selectedTab;
        const requestData = {
          items: items.map(item => ({
            item_id:
              itemType === "screen"
                ? item.screen_id
                : itemType === "property"
                  ? item.property_id
                  : item.card_id,
            item_type: itemType,
          }))
        };
        await trashApi.deleteItem(requestData);

        this.fetchTrashItems();
        alert("削除が完了しました");
      } catch (error) {
        console.error("削除中のエラー:", error);
      }
    },
    toggleAllCheck() {
      if (this.selectedTab === 'screen') {
        if (this.isAllChecked) {
          this.selectedItems = [];
        } else {
          this.selectedItems = [...this.filteredTrashItems];
        }
        this.isAllChecked = !this.isAllChecked;
      } else if (this.selectedTab === 'property') {
        if (this.isAllChecked2) {
          this.selectedItems2 = [];
        } else {
          this.selectedItems2 = [...this.filteredProperties];
        }
        this.isAllChecked2 = !this.isAllChecked2;
      } else if (this.selectedTab === 'card') {
        if (this.isAllChecked3) {
          this.selectedItems3 = [];
        } else {
          this.selectedItems3 = [...this.filteredCards];
        }
        this.isAllChecked3 = !this.isAllChecked3;
      }
    },
    allDelete() {
      if (this.selectedTab === 'screen') {
        if (this.selectedItems.length > 0) {
          this.handleDelete(this.selectedItems);
          this.isAllChecked = !this.isAllChecked;
        } else {
          alert("削除する項目が選択されていません");
        }
      } else if (this.selectedTab === 'property') {
        if (this.selectedItems2.length > 0) {
          this.handleDelete(this.selectedItems2);
          this.isAllChecked2 = !this.isAllChecked2;
        } else {
          alert("削除する項目が選択されていません");
        }
      } else if (this.selectedTab === 'card') {
        if (this.selectedItems3.length > 0) {
          this.handleDelete(this.selectedItems3);
          this.isAllChecked3 = !this.isAllChecked3;
        } else {
          alert("削除する項目が選択されていません");
        }
      }
    },
    allRestore() {
      if (this.selectedTab === 'screen') {
        if (this.selectedItems.length > 0) {
          this.handleRestore(this.selectedItems);
        } else {
          alert("削除する項目が選択されていません");
        }
      } else if (this.selectedTab === 'property') {
        if (this.selectedItems2.length > 0) {
          this.handleRestore(this.selectedItems2);
        } else {
          alert("削除する項目が選択されていません");
        }
      } else if (this.selectedTab === 'card') {
        if (this.selectedItems3.length > 0) {
          this.handleRestore(this.selectedItems3);
        } else {
          alert("削除する項目が選択されていません");
        }
      }
    }
  },
  mounted() {
    eventBus.on("refreshTrash", this.getDataFromApi);
  },
  computed: {
    containerStyle() {
      return {
        marginLeft: this.isSidebarClosed ? "12%" : "22%",
        width: this.isSidebarClosed ? "100%" : "85%",
      };
    },
    filteredTrashItems() {
      const query = this.searchQuery.toLowerCase();
      if (!query) return this.trashItems;
      return this.trashItems.filter(
        (item) =>
          item.screen_name && item.screen_name.toLowerCase().includes(query)
      );
    },
    filteredProperties() {
      const query = this.searchQuery.toLowerCase();
      if (!query) return this.properties;
      return this.properties.filter(
        (item) =>
          item.property_name && item.property_name.toLowerCase().includes(query)
      );
    },
    filteredCards() {
      const query = this.searchQuery.toLowerCase();
      if (!query) return this.cards;
      return this.cards.filter(
        (item) => item.title && item.title.toLowerCase().includes(query)
      );
    },
  },
};
</script>

<style scoped>
.trash-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 50%;
  margin-left: 5%;
}

.header {
  display: flex;
  align-items: content;
  justify-content: space-between;
  width: 85%;
}

h3 {
  margin-top: 40px;
  margin-top: 40px;
}

.search-input {
  color: blue;
  padding: 10px;
  width: 100%;
  max-width: 280px;
  font-size: 16px;
  top: 32px;
  right: 92px;
  position: absolute;
  border: none;
  border-bottom: 1px solid;
  outline: none;
}

.search-input::placeholder {
  color: blue;
  opacity: 0.5;
}

.tabs {
  display: flex;
  justify-content: flex-start;
  width: 40%;
  margin-bottom: 20px;
  margin-top: 10px;
}

.tabs button {
  padding: 10px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 12px;
  background-color: #f1f1f1;
  margin-right: 8px;
  text-align: center;
  font-weight: bold;
}

.tabs button.active {
  background-color: black;
  color: white;
}

.section {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 8px;
  width: 85%;
  max-width: 1100px;
  margin-top: 20px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: left;
}

.item-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background-color: white;
  margin-bottom: 10px;
  transition: background-color 0.3s;
}

.item-card:hover {
  background-color: #f0f0f0;
}

.item-info {
  font-size: 16px;
}

.item-actions {
  display: flex;
}

.item-actions button {
  margin-left: 10px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.all-button {
  display: flex;
}

.left-buttons {
  display: flex;
}

.right-buttons {
  display: flex;
  margin-left: auto;
}

.right-buttons button {
  justify-content: center;
  align-items: center;
}

.all-button button {
  margin-left: 10px;
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-align: center;
  width: 110px;
}

.restore-btn {
  background-color: blue;
  color: white;
}

.restore-btn:hover {
  background-color: blue;
}

.delete-btn {
  background-color: white;
  border: 1px solid blue;
  color: blue;
}

.delete-btn:hover {
  background-color: white;
  border: 1px solid blue;
}

.all-select-btn {
  background-color: white;
  border: 1px solid blue;
  color: blue;
}

.all-select-btn:hover {
  background-color: white;
  border: 1px solid blue;
}

.all-select-btn:disabled {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  color: #aaa;
  cursor: not-allowed;
}

.all-delete-btn {
  background-color: white;
  border: 1px solid blue;
  color: blue;
  display: flex;
  justify-content: flex-end;
}

.all-delete-btn:hover {
  background-color: white;
  border: 1px solid blue;
}

.all-delete-btn:disabled {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  color: #aaa;
  cursor: not-allowed;
}

.all-restore-btn {
  background-color: blue;
  color: white;
  display: flex;
  justify-content: flex-end;
}

.all-restore-btn:hover {
  background-color: blue;
}

.all-restore-btn:disabled {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  color: #aaa;
  cursor: not-allowed;
}

.sub-screen-name {
  color: #888;
  font-size: 14px;
}

.item-texts {
  display: flex;
  flex-direction: column;
  margin: 0 10px;
}
</style>
